module.exports = __webpack_public_path__ + "b6fa3c93c69f0a91b9975febada9f155.svg";